import { type FC } from 'react'
import { type DefaultProps } from '../common'
import { PageHeaderRedesign } from './page-header-redesign'

export interface PageHeaderProps extends DefaultProps {
  /**
   * Header title
   */
  title?: string
  /**
   * Header breadcrumb
   */
  subtitle?: string
  /**
   * Back link url
   */
  backLinkUrl?: string
  /**
   * Title class name
   */
  titleClassName?: string
  /**
   * Last Refreshed
   */
  lastRefreshed?: string
}

export const PageHeader: FC<PageHeaderProps> = (props) => {
  return <PageHeaderRedesign {...props} />
}
